import { render, staticRenderFns } from "./joinus.vue?vue&type=template&id=14d4169a&scoped=true&"
import script from "./joinus.vue?vue&type=script&lang=js&"
export * from "./joinus.vue?vue&type=script&lang=js&"
import style0 from "./joinus.vue?vue&type=style&index=0&id=14d4169a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d4169a",
  null
  
)

export default component.exports